import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { companyConfigConstants } from '..';

export const useCompanyConfigDocumentTemplateFormat = () => {
  const data = useQuery<'WORD' | 'PDF'>({
    queryKey: [companyConfigConstants.queryKeys.COMPANY_CONFIG_DOCUMENT_TEMPLATE_FORMAT],
    queryFn: async () => {
      const res = await $api.get('/v1/company-config/document-template/format');

      return res?.data?.data;
    },
    staleTime: Infinity
  });

  return { ...data, isWord: data?.data === 'WORD', isPdf: data?.data === 'PDF' };
};
